import { Routes } from '@angular/router';
import { MissingPriceConfigurationsReportComponent } from './missing-price-configurations-report.component';

export const MISSING_PRICE_CONFIGURATIONS_REPORT_ROUTES: Routes = [
  {
    path: 'missing-price-configurations-report',
    component: MissingPriceConfigurationsReportComponent
  }
];
